import React, { useState, useEffect } from 'react';
import { Box, Typography, Drawer, IconButton, Button  } from '@mui/material';

import { useMediaQuery } from "@mui/material";

import { collection, onSnapshot, doc, getDocs,setDoc, writeBatch, deleteDoc, updateDoc, addDoc, query, where } from 'firebase/firestore';
import {db} from '../../firebaseConfig';

import CloseIcon from '@mui/icons-material/Close';

import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import EditIcon from '@mui/icons-material/EditOutlined';

import PdfThumbnail from '../../images/PdfThumbnail.png'; // import a component or image for PDF thumbnail
import GenericFileThumbnail from '../../images/GenericFileThumbnail.png'; // import a component or image for generic file thumbnail

import { useTheme } from "@mui/material";

import { tokens } from "../../theme";

import { useUser } from "../../common/UserContext";
import { useApplicationMode } from "../../common/ApplicationModeContext";


const generatePartnershipTypeColorMapDrawer = (partnerships,theme) => {
  
        const partnershipTypeColorMap = {};
        
        const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;

        partnerships.forEach(partnership => {
          if (!partnershipTypeColorMap[partnership.partnershipType]) {
            partnershipTypeColorMap[partnership.partnershipType] = colorFunction(partnership.partnershipType);
          }
        });
      
        return partnershipTypeColorMap;
      };
      


    const generateAssociatedCauseIdsColorMapDrawer = (partnerships, AssociatedCauseIdsMap,theme) => {
        const associatedCauseIdsColorMap = {};
        const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;
        partnerships.forEach(partnership => {
          (partnership.associatedCauseIds || []).forEach(itemId => {
            const item = AssociatedCauseIdsMap[itemId];
            if (item && !associatedCauseIdsColorMap[item]) {
                associatedCauseIdsColorMap[item] = colorFunction(item);
            }
          });
        });
        return associatedCauseIdsColorMap;
      };
      

    const generateAssociatedEventIdsColorMapDrawer = (partnerships, AssociatedEventIdsMap,theme) => {
        const associatedEventIdsColorMap = {};
        const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;
        partnerships.forEach(partnership => {
          (partnership.associatedEventIds || []).forEach(itemId => {
            const item = AssociatedEventIdsMap[itemId];
            if (item && !associatedEventIdsColorMap[item]) {
                associatedEventIdsColorMap[item] = colorFunction(item);
            }
          });
        });
        return associatedEventIdsColorMap;
      };
      

    const generateAssociatedVolunteerIdsColorMapDrawer = (partnerships, AssociatedVolunteerIdsMap,theme) => {
        const associatedVolunteerIdsColorMap = {};
        const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;
        partnerships.forEach(partnership => {
          (partnership.associatedVolunteerIds || []).forEach(itemId => {
            const item = AssociatedVolunteerIdsMap[itemId];
            if (item && !associatedVolunteerIdsColorMap[item]) {
                associatedVolunteerIdsColorMap[item] = colorFunction(item);
            }
          });
        });
        return associatedVolunteerIdsColorMap;
      };
      

    const generatePartnershipGoalsColorMapDrawer = (partnerships,theme) => {
        const partnershipGoalsColorMap = {};
        const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;
        for (const partnership of partnerships)
        {
            if (partnership.partnershipGoals != null)
            {
               for (const itemId of partnership.partnershipGoals)
               {
                    const item = itemId;
                    if (item && !partnershipGoalsColorMap[item]) {
                        partnershipGoalsColorMap[item] = colorFunction(item);
                    }
                }
            }
        }
        return partnershipGoalsColorMap;
      };
      

    const generateAssociatedDonorIdsColorMapDrawer = (partnerships, AssociatedDonorIdsMap,theme) => {
        const associatedDonorIdsColorMap = {};
        const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;
        partnerships.forEach(partnership => {
          (partnership.associatedDonorIds || []).forEach(itemId => {
            const item = AssociatedDonorIdsMap[itemId];
            if (item && !associatedDonorIdsColorMap[item]) {
                associatedDonorIdsColorMap[item] = colorFunction(item);
            }
          });
        });
        return associatedDonorIdsColorMap;
      };
      


const stringToColorLight = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    // Ensuring that the color values are always light by adding a base value of 127
    const lightValue = ((value + 127) % 128) + 127;
    color += ('00' + lightValue.toString(16)).substr(-2);
  }
  return color;
};


const stringToColorDark = (str) => {
  
  return stringToColorLight(str); // We will use the same colors
};


const PartnershipDrawerModal = ({ drawerOpen, handleDrawerClose,handleArrowUpClick,handleArrowDownClick, selectedPartnership, partnerships, handleOpenEdit }) => {

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const { appUserAccountNumber } = useUser();
  const { applicationMode } = useApplicationMode();
    
  const data = selectedPartnership;

  const [associatedCauseIdsMap, setAssociatedCauseIdsMap] = useState({});
const [associatedEventIdsMap, setAssociatedEventIdsMap] = useState({});
const [associatedVolunteerIdsMap, setAssociatedVolunteerIdsMap] = useState({});
const [associatedDonorIdsMap, setAssociatedDonorIdsMap] = useState({});

  
  
                const formatAssociatedCauseIds = value => {

                    let formattedAssociatedCauseIds = "";

                    if (value != null)
                    {
                    formattedAssociatedCauseIds = (value|| []).map(id => associatedCauseIdsMap[id]).join(', ') || '';
                    }
                    
                    return formattedAssociatedCauseIds;
                };
                              
                

                const formatAssociatedEventIds = value => {

                    let formattedAssociatedEventIds = "";

                    if (value != null)
                    {
                    formattedAssociatedEventIds = (value|| []).map(id => associatedEventIdsMap[id]).join(', ') || '';
                    }
                    
                    return formattedAssociatedEventIds;
                };
                              
                

                const formatAssociatedVolunteerIds = value => {

                    let formattedAssociatedVolunteerIds = "";

                    if (value != null)
                    {
                    formattedAssociatedVolunteerIds = (value|| []).map(id => associatedVolunteerIdsMap[id]).join(', ') || '';
                    }
                    
                    return formattedAssociatedVolunteerIds;
                };
                              
                

                const formatAssociatedDonorIds = value => {

                    let formattedAssociatedDonorIds = "";

                    if (value != null)
                    {
                    formattedAssociatedDonorIds = (value|| []).map(id => associatedDonorIdsMap[id]).join(', ') || '';
                    }
                    
                    return formattedAssociatedDonorIds;
                };
                              
                

  
  
    useEffect(() => {
        const fetchStaticData = async () => {
            	const associatedCauseIdsSnapshot = await getDocs(query(collection(db, "charitableCauses"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const associatedCauseIdsData = associatedCauseIdsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const associatedCauseIdsMap = associatedCauseIdsData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.title }), {});
	setAssociatedCauseIdsMap(associatedCauseIdsMap);

	const associatedEventIdsSnapshot = await getDocs(query(collection(db, "events"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const associatedEventIdsData = associatedEventIdsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const associatedEventIdsMap = associatedEventIdsData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.title }), {});
	setAssociatedEventIdsMap(associatedEventIdsMap);

	const associatedVolunteerIdsSnapshot = await getDocs(query(collection(db, "volunteers"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const associatedVolunteerIdsData = associatedVolunteerIdsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const associatedVolunteerIdsMap = associatedVolunteerIdsData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.firstName }), {});
	setAssociatedVolunteerIdsMap(associatedVolunteerIdsMap);

	const associatedDonorIdsSnapshot = await getDocs(query(collection(db, "donors"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const associatedDonorIdsData = associatedDonorIdsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const associatedDonorIdsMap = associatedDonorIdsData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.firstName }), {});
	setAssociatedDonorIdsMap(associatedDonorIdsMap);



        };

        fetchStaticData();
      }, []);
    
    

  const [partnershipTypeColorMap, setPartnershipTypeColorMap] = useState({});
const [activeColorMap, setActiveColorMap] = useState({});
const [associatedCauseIdsColorMap, setAssociatedCauseIdsColorMap] = useState({});
const [associatedEventIdsColorMap, setAssociatedEventIdsColorMap] = useState({});
const [associatedVolunteerIdsColorMap, setAssociatedVolunteerIdsColorMap] = useState({});
const [partnershipGoalsColorMap, setPartnershipGoalsColorMap] = useState({});
const [associatedDonorIdsColorMap, setAssociatedDonorIdsColorMap] = useState({});


//USE EFFECT TO CHANGE COLOR MAP when it changes
useEffect(() => {
  setPartnershipTypeColorMap(generatePartnershipTypeColorMapDrawer(partnerships,theme));

setAssociatedCauseIdsColorMap(generateAssociatedCauseIdsColorMapDrawer(partnerships, associatedCauseIdsMap,theme));
setAssociatedEventIdsColorMap(generateAssociatedEventIdsColorMapDrawer(partnerships, associatedEventIdsMap,theme));
setAssociatedVolunteerIdsColorMap(generateAssociatedVolunteerIdsColorMapDrawer(partnerships, associatedVolunteerIdsMap,theme));
setPartnershipGoalsColorMap(generatePartnershipGoalsColorMapDrawer(partnerships, theme));
setAssociatedDonorIdsColorMap(generateAssociatedDonorIdsColorMapDrawer(partnerships, associatedDonorIdsMap,theme));

}, [theme.palette.mode, drawerOpen, partnerships ,associatedCauseIdsMap,associatedEventIdsMap,associatedVolunteerIdsMap,associatedDonorIdsMap]);


  const formatFirestoreDate = timestamp => {

    if (timestamp != null && timestamp !== "")
    {
      const dateStr = new Date(timestamp.seconds * 1000).toISOString().slice(0, 10);
      const parts = dateStr.split('-');
      return `${parts[1]}/${parts[2]}/${parts[0]}`;
    } else 
    {
      return "";
    }
  };

  const formatFirestoreTime = timestamp => {

   if (timestamp != null && timestamp !== "")
   { 
        // Convert the seconds since Unix epoch to a Date object
      const date = new Date(timestamp.seconds * 1000);

      // Extract hours and minutes
      let hours = date.getHours();
      const minutes = date.getMinutes();

      // Determine AM or PM
      const period = hours >= 12 ? 'PM' : 'AM';

      // Convert hours to 12-hour format
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'

      // Format hours and minutes as a time string in "hh:mm AM/PM" format
      const formattedHours = hours.toString().padStart(2, '0');
      const formattedMinutes = minutes.toString().padStart(2, '0');

      return `${formattedHours}:${formattedMinutes} ${period}`;
   } else
   {
    return "";
   }
  };


  const formatPhoneNumber = value => {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };

  const formatCurrencyInteger = value => {
  
    if (value != null && value !=="")
    {
      return `$${Number(value).toLocaleString()}`;
    } else 
    {
      return "";
    }
  };

  const formatCurrency = (value) => {

    if (value != null && value !=="")
    {
          value = value.toString();
          // Remove all non-numeric characters except for the decimal point
          let result = value.replace(/[^0-9.]/g, '');
        
          // If there are multiple decimal points, keep only the first one
          const parts = result.split('.');
          if (parts.length > 2) {
            result = parts[0] + '.' + parts.slice(1).join('');
          }
        
          // Allow at most two decimal places
          if (parts.length === 2 && parts[1].length > 2) {
          
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1].substring(0, 2);
          } else if (parts.length === 2 && parts[1].length <= 2) 
          {
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
          }else
          {
            result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          }
          return result ? `$${result}` : '';

      } else 
      {
        return "";
      }
  };


  const formatDecimal = (value) => {

    if (value != null && value !=="")
    {
          value = value.toString();
          // Remove all non-numeric characters except for the decimal point
          let result = value.replace(/[^0-9.]/g, '');
        
          // If there are multiple decimal points, keep only the first one
          const parts = result.split('.');
          if (parts.length > 2) {
            result = parts[0] + '.' + parts.slice(1).join('');
          }
        
          // Allow at most two decimal places
          if (parts.length === 2 && parts[1].length > 2) {
          
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1].substring(0, 2);
          } else if (parts.length === 2 && parts[1].length <= 2) 
          {
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
          }else
          {
            result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          }
          return result ? `${result}` : '';
  
      } else 
      {
        return "";
      }
  };
  
  
  const formatInteger = (value) => {
  
    if (value != null && value !=="")
    {
          value = value.toString();
          // Remove all non-numeric characters except for the decimal point
          let result = value.replace(/[^0-9]/g, '');
        
          result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          
          return result ? `${result}` : '';
  
      } else 
      {
        return "";
      }
  };


  const getFileExtension = (fileName) => {
    return fileName.split('.').pop().toLowerCase();
  };

  const renderFile = (fileContent,fileName) => {
    if (!fileContent || !fileName) return null;
    const fileType = getFileExtension(fileName);
    if (fileType === 'pdf') {
      return <img src={PdfThumbnail} title={fileName} alt="PDF thumbnail" onClick={() => handleFileClick(fileType,fileContent,fileName)} style={{ cursor: 'pointer',height:'100px',width:'81px' }} />;
    } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileType)) {
      return <img src={fileContent} title={fileName} alt="Profile thumbnail" onClick={() => handleFileClick(fileType,fileContent,fileName)} style={{ cursor: 'pointer', maxWidth: '400px', maxHeight: '400px' }} />;
    } else {
      return <img src={GenericFileThumbnail} title={fileName} alt="File thumbnail" onClick={() => handleFileClick(fileType,fileContent,fileName)} style={{ cursor: 'pointer',height:'100px',width:'77px'  }} />;
    }
  };

  const handleFileClick = (fileType,fileContent,fileName) => {
    if (fileType === 'pdf') {
      
      const base64String = fileContent.split(',')[1]; // Extract base64 string from data URL
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
  
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);
  
      window.open(blobUrl, '_blank');

    } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileType)) {
      const image = new Image();
      image.src = fileContent;
    
      image.onload = () => {
        let width = image.naturalWidth;
        let height = image.naturalHeight;
        const padding = 50;
    
        // Get browser window dimensions
        const maxWidth = window.innerWidth - padding;
        const maxHeight = window.innerHeight - padding;
    
        // Resize the image if it's larger than the browser window
        if (width > maxWidth || height > maxHeight) {
          const widthRatio = maxWidth / width;
          const heightRatio = maxHeight / height;
          const minRatio = Math.min(widthRatio, heightRatio);
    
          width = Math.floor(width * minRatio);
          height = Math.floor(height * minRatio);
        }
    
        // Calculate the position to center the window
        const left = (window.screen.width / 2) - (width / 2);
        const top = (window.screen.height / 2) - (height / 2);
    
        // Open the window with the calculated position and size
        const w = window.open("", "", `width=${width + padding},height=${height + padding},left=${left},top=${top}`);
        image.style.width = `${width}px`;
        image.style.height = `${height}px`;
        w.document.write(image.outerHTML);
      };
        
    } else {
      const link = document.createElement('a');
      link.href = fileContent;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  

    return (
        <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerClose}>
          <div>
          <Box sx={{ width: 600, padding: 2, backgroundColor:colors.drawerModalBackgroundColor, height: '100%', minHeight: '100vh'  }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">

              {handleArrowDownClick ? (
              <Box display="flex">
                <IconButton onClick={handleArrowUpClick}>
                  <KeyboardArrowUpIcon />
                </IconButton>
                <IconButton onClick={handleArrowDownClick}>
                  <KeyboardArrowDownIcon />
                    </IconButton>
                </Box>

              ) : (
                <Box display="flex">
                  &nbsp;
                </Box>
              )}

                <IconButton onClick={handleDrawerClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
              
                {selectedPartnership && (
                    <>
                      <h1>{data.id}</h1>
    <Button variant="contained" color="primary" sx={{ float:'right',backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }} onClick={() => handleOpenEdit(selectedPartnership.id)}>
        <EditIcon /> &nbsp; EDIT PARTNERSHIP
    </Button>
                    
     <Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>PARTNER NAME:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
{data.partnerName ? data.partnerName.toString() : ""}</Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>PARTNERSHIP TYPE:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>

                    <Box
                                key={data.partnershipType}
                                sx={{ 
                                    backgroundColor: partnershipTypeColorMap[data.partnershipType], 
                                    borderRadius: '13px', 
                                    padding: '2px 8px', 
                                    display: 'inline-block', 
                                    marginRight: '4px',
                                    marginBottom: '4px',
                                    color: theme.palette.mode === "dark" ? '#000000' : '#000000',
                                    fontWeight:'600'  
                                }}
                                >
                                    { data.partnershipType ? data.partnershipType.toString() : "" }

                                </Box>
                    </Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>START DATE:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
{formatFirestoreDate(data.partnershipStartDate)}</Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>END DATE:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
{formatFirestoreDate(data.partnershipEndDate)}</Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>CONTACT INFORMATION:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
{data.contactInformation ? data.contactInformation.toString() : ""}</Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>ACTIVE:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
</Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>CAUSES:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>

                        <Box>
                        {(data.associatedCauseIds || []).map(id => (
                            <Box
                            key={id}
                            sx={{ 
                                backgroundColor: associatedCauseIdsColorMap[associatedCauseIdsMap[id]], 
                                borderRadius: '13px', 
                                padding: '2px 8px', 
                                display: 'inline-block', 
                                marginRight: '4px',
                                marginBottom: '4px',
                                color: theme.palette.mode === "dark" ? '#000000' : '#000000',
                                fontWeight:'600' 
                            }}
                            >
                            {associatedCauseIdsMap[id]}
                            </Box>
                        ))}
                        </Box>
                    </Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>EVENTS:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>

                        <Box>
                        {(data.associatedEventIds || []).map(id => (
                            <Box
                            key={id}
                            sx={{ 
                                backgroundColor: associatedEventIdsColorMap[associatedEventIdsMap[id]], 
                                borderRadius: '13px', 
                                padding: '2px 8px', 
                                display: 'inline-block', 
                                marginRight: '4px',
                                marginBottom: '4px',
                                color: theme.palette.mode === "dark" ? '#000000' : '#000000',
                                fontWeight:'600' 
                            }}
                            >
                            {associatedEventIdsMap[id]}
                            </Box>
                        ))}
                        </Box>
                    </Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>VOLUNTEERS:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>

                        <Box>
                        {(data.associatedVolunteerIds || []).map(id => (
                            <Box
                            key={id}
                            sx={{ 
                                backgroundColor: associatedVolunteerIdsColorMap[associatedVolunteerIdsMap[id]], 
                                borderRadius: '13px', 
                                padding: '2px 8px', 
                                display: 'inline-block', 
                                marginRight: '4px',
                                marginBottom: '4px',
                                color: theme.palette.mode === "dark" ? '#000000' : '#000000',
                                fontWeight:'600' 
                            }}
                            >
                            {associatedVolunteerIdsMap[id]}
                            </Box>
                        ))}
                        </Box>
                    </Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>PARTNERSHIP VALUE:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
{formatCurrency(data.partnershipValue)}</Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>GOALS:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>

                            <Box>
                            {(data.partnershipGoals || []).map(value => (
                                <Box
                                key={value}
                                sx={{ 
                                    backgroundColor: partnershipGoalsColorMap[value], 
                                    borderRadius: '13px', 
                                    padding: '2px 8px', 
                                    display: 'inline-block', 
                                    marginRight: '4px',
                                    marginBottom: '4px',
                                    color: theme.palette.mode === "dark" ? '#000000' : '#000000' ,
                                    fontWeight:'600' 
                                }}
                                >
                                {value.replaceAll("_"," ")}
                                </Box>
                            ))}
                            </Box>
                        </Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>DONORS:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>

                        <Box>
                        {(data.associatedDonorIds || []).map(id => (
                            <Box
                            key={id}
                            sx={{ 
                                backgroundColor: associatedDonorIdsColorMap[associatedDonorIdsMap[id]], 
                                borderRadius: '13px', 
                                padding: '2px 8px', 
                                display: 'inline-block', 
                                marginRight: '4px',
                                marginBottom: '4px',
                                color: theme.palette.mode === "dark" ? '#000000' : '#000000',
                                fontWeight:'600' 
                            }}
                            >
                            {associatedDonorIdsMap[id]}
                            </Box>
                        ))}
                        </Box>
                    </Typography>
</Box><hr/>
                    </>
                )}
            </Box>
            </div>
        </Drawer>
    );
};

export default PartnershipDrawerModal;
